// extracted by mini-css-extract-plugin
export default {"columnForm":"ColumnForm_columnForm__Nf1Nv","title":"ColumnForm_title__bHjUn"};